import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import FormatPrice from '@shared/containers/FormatPrice';
import messages from '../messages';

function DeliveryAmount({ amount }) {
  if (amount === 0)
    return <FormattedMessage {...messages.deliveryAmountNoMin} />;

  return (
    <FormatPrice value={amount}>
      {price => (
        <FormattedMessage
          {...messages.deliveryAmount}
          values={{ minDeliveryAmount: price }}
        />
      )}
    </FormatPrice>
  );
}

DeliveryAmount.propTypes = {
  amount: PropTypes.number.isRequired,
};

export default DeliveryAmount;
